// extracted by mini-css-extract-plugin
export default {"registerLink":"Anonymous_registerLink__Hq7y2","loginLink":"Anonymous_loginLink__7TVP+","registerLinkNone":"Anonymous_registerLinkNone__AFAre"};